import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory from "react-bootstrap-table2-filter"; // , {textFilter, selectFilter, dateFilter,}
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"; // , { Search, CSVExport,}
// import cellEditFactory from "react-bootstrap-table2-editor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { toast } from "react-toastify";
import { Row, Col, Form, Button, FormControl } from "react-bootstrap";
// import { CSVLink } from "react-csv";

// Import Service
import assocService from "../../services/assoc.service";
import authService from "../../services/auth.service";
import farmerService from "../../services/farmer.service";

//Import Loading
// import Spinner from "react-bootstrap/Spinner";
import LoadingAlert from "../../components/LoadingAlert";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

// Import Modal
import ModalViewDetail from "./modalViewAssocMembers";
import ModalAddAssociation from "./modalAddAssociation";
import ModalEditAssociation from "./modalEditAssociation";
import ModalCheckMember from "./modalCheckMember";
import MemberForm from "./formMember";

//Import tooltip
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import "./association.css";

const AssociationSummary = () => {
  const [loading, setLoading] = useState(false);
  // const [loadingAlert, setLoading] = useState(false);
  const [show_view, setShow_view] = useState(false);
  const [show_add, setShow_add] = useState(false);
  const [show_edit, setShow_edit] = useState(false);
  // const [data_select, setData_select] = useState(0);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [user_id, setUser_id] = useState(0);
  // const [association_name, setAssociation_name] = useState("");
  const [showFormCheck, setShowFormCheck] = useState(false);
  const [showMemberForm, setShowMemberForm] = useState(false);
  const [farmer, setFarmer] = useState({});
  const [association, setAssociation] = useState({});
  const [search, setSearch] = useState({});

  // const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;

  const user = authService.getCurrentUser();
  useEffect(() => {
    getData();
    // setLoading(false);
  }, []);

  const getFarmer = (farmer_idcard) => {
    farmerService.getFarmerById(farmer_idcard).then((response) => {
      setFarmer(response.data.farmer);
    });
  };

  const getAssociation = (assoc_id) => {
    assocService.getAssociationById(assoc_id).then((response) => {
      setAssociation(response.data.data);
    });
  };

  const getData = () => {
    console.log(search);
    setData([]);
    setLoading(true);
    assocService
      .getAssocSummary(search)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
        // setLoading(false);
      });
  };

  // const clickCheckMember = (row) => {
  //   console.log("clickCheckMember");
  //   console.log(row);
  //   setAssociation(row);
  //   setShowFormCheck(true);
  // };

  const clickAddMember = (form) => {
    getFarmer(form.search);
    getAssociation(form.assoc);
    setShowFormCheck(false);
    setShowMemberForm(true);

    // alert(JSON.stringify(form));
  };

  const clickDeleteAssoc = (row) => {
    console.log(row);
    confirmAlert({
      title: "",
      message: "ต้องการลบใช่หรือไม่",
      buttons: [
        {
          label: "ใช่",
          onClick: () => {
            assocService
              .deleteAssociation(row.association_id)
              .then((response) => {
                if (response.data.success) {
                  setLoading(true);
                  setData((data) =>
                    data.filter((a) => a.association_id != row.association_id)
                  );
                }
              })
              .catch((error) => {
                console.error("error fetching data: ", error);
                setError(error);
              })
              .finally(() => {
                setLoading(false);
              });
          },
        },
        {
          label: "ไม่ใช่",
          onClick: () => false,
        },
      ],
      overlayClassName: "confirm-alert-2button",
    });
  };

  const onSubmitAssocSave = (e) => {
    const fromdata = {
      ...e,
    };
    setLoading(true);
    assocService
      .createNewAssoc(fromdata)
      .then((response) => {
        console.log(response.data.data);
        setData([response.data.data, ...data]);
      })
      .catch((error) => {
        console.error("error add data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
        setShow_add(false);
      });
  };

  const onSubmitSave = (e) => {
    const formdata = {
      ...e,
      assocId: user.user.user_assoc ? user.user.user_assoc : e.assocId,
      user_id: user.user.user_id,
    };
    // console.log(formdata);
    setLoading(true);
    assocService
      .createMember(formdata)
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setData([response.data.data, ...data]);
          // console.log(data);
        }
      })
      .catch((error) => {
        console.error("error add data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
        setShowMemberForm(false);
      });
  };

  const handleClickAdd = () => {
    setShow_add(true);
  };

  const clickViewData = (row) => {
    console.log("View");
    setLoading(true);
    setAssociation(row);
    setShow_view(true);
    setLoading(false);
    console.log(row);
  };

  const handleCloseView = () => {
    setLoading(false);
    setShow_view(false);
  };

  const clickEditAssoc = (row) => {
    // console.log(parseInt(row.members.replace(/,/g, "")));
    // console.log(row);
    console.log("Edit");
    setAssociation(row);
    // setAssociation_id(id);
    setUser_id(user.user.user_id);
    setShow_edit(true);
  };

  const ActionsView = (row) => {
    return (
      <>
        <i
          className="bi bi-search custom-icon-table"
          onClick={() => clickViewData(row.row)}
        ></i>
      </>
    );
  };

  const ActionsEdit = (row) => {
    return (
      <>
        {/* <i
          className="text-success bi bi-person-plus custom-icon-table"
          onClick={() => clickCheckMember(row.row)}
        ></i> */}
        <i
          className="bi bi-search custom-icon-table"
          onClick={() => clickViewData(row.row)}
        ></i>
        <i
          className="bi bi-pencil custom-icon-table"
          onClick={() => clickEditAssoc(row.row)}
        ></i>
        {parseInt(row.row.members) === 0 ? (
          <i
            className="bi bi-trash custom-icon-table"
            onClick={() => clickDeleteAssoc(row.row)}
            style={{ color: "red" }}
            title="ลบข้อมูลสมาคม"
          ></i>
        ) : (
          ""
        )}
      </>
    );
  };

  const actionsViewFormatter = (cell, row) => {
    if (user.user.member_type === 5 || user.user.member_type === 8) {
      return <ActionsView row={row} />;
    } else if (user.user.member_type === 6) {
      return <ActionsEdit row={row} />;
    }
  };

  const showCSVButton = (prop) => {
    if (user.user.member_type === 5 || user.user.member_type === 8) {
      return (
        <ExportCSVButton
          {...prop.csvProps}
          style={{
            padding: ".375rem .75rem",
            fontSize: "1rem",
            float: "right",
          }}
        >
          <i className="bi bi-download"></i>
        </ExportCSVButton>
      );
    } else if (user.user.member_type === 6) {
      return (
        <div>
          <ExportCSVButton
            {...prop.csvProps}
            style={{
              padding: ".375rem .75rem",
              fontSize: "1rem",
              float: "right",
            }}
          >
            <i className="bi bi-download"></i>
          </ExportCSVButton>
          <button
            className="btn btn-primary"
            onClick={handleClickAdd}
            style={{
              padding: ".375rem .75rem",
              fontSize: "1rem",
              float: "right",
            }}
          >
            เพิ่มสมาคม
          </button>
        </div>
      );
    }
  };

  const formatActive = (cell) => {
    if (cell == 1) {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-success">ใช้งาน</p>
        </OverlayTrigger>
      );
    } else {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-danger">ยกเลิก</p>
        </OverlayTrigger>
      );
    }
  };

  const filterRegions = {
    1: "กลาง",
    2: "เหนือ",
    3: "ตะวันออกเฉียงเหนือ",
    4: "ตะวันออก",
    0: "ไม่ระบุ",
  };

  const optionRegion = [
    { value: "1", label: "กลาง" },
    { value: "2", label: "เหนือ" },
    { value: "3", label: "ตะวันออกเฉียงเหนือ" },
    { value: "4", label: "ตะวันออก" },
    { value: "0", label: "ไม่ระบุ" },
  ];

  const optionActive = [
    { value: 1, label: "ใช้งาน" },
    { value: 0, label: "ยกเลิก" },
  ];

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  const renderTooltip = (props) =>
    user.user.member_type === 6 ? (
      <Tooltip {...props}>คลิ๊กเพื่อแก้ไขสถานะ</Tooltip>
    ) : (
      <span></span>
    );
  const handleSearch = (e) => {
    e.preventDefault();
    getData();
  };

  const setField = (field, value) => {
    console.log(search);
    setSearch({
      ...search,
      [field.name]: value,
    });
  };

  const changeStatus = (body) => {
    console.log(body);
    assocService
      .activateAssociation(body)
      .then((res) => {
        if (res.data.success) {
          // toast.success(res.data.message);
          toast.success("แก้ไขเรียบร้อย !!", {
            position: "bottom-left",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err));
  };

  const columns = [
    {
      dataField: "associd",
      isDummyField: true,
      sort: true,
      hidden: true,
      csvExport: false,
    },
    {
      text: "สถานะ",
      formatter: formatActive,
      // formatter: (cell) => filterActive[cell],
      // filter: selectFilter({
      //   placeholder: "เลือกภูมิภาค",
      //   style: { fontSize: "98%", width: "100%" },
      //   options: filterActive,
      // }),
      dataField: "assocstatus",
      sort: true,
      editable: user.user.member_type === 6 ? true : false,
      editor: {
        type: Type.SELECT,
        options: optionActive,
        style: { placeholder: "select", fontSize: "98%" },
      },
      headerSortingStyle,
      headerStyle: () => {
        return { width: "5%" };
      },
    },
    {
      text: "ภูมิภาค",
      formatter: (cell) => filterRegions[cell],
      // filter: selectFilter({
      //   placeholder: "เลือกภูมิภาค",
      //   style: { fontSize: "98%", width: "100%" },
      //   options: filterRegions,
      // }),
      dataField: "assocregion",
      sort: true,
      editable: false,
      // editor: {
      //   type: Type.SELECT,
      //   options: optionRegions,
      //   style: { placeholder: "select", fontSize: "98%" },
      // },
      headerSortingStyle,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      text: "สมาคม",
      // filter: textFilter({
      //   placeholder: "ค้นหา",
      //   style: { fontSize: "98%", width: "100%" },
      // }),
      dataField: "assocname",
      sort: true,
      editable: false,
      headerSortingStyle,
      headerStyle: () => {
        return { width: "25%" };
      },
      style: {
        textAlign: "left",
      },
    },
    {
      text: "สมาชิกรวม",
      dataField: "members",
      sort: true,
      editable: false,
      headerSortingStyle,
      headerStyle: () => {
        return { width: "10%" };
      },
      style: {
        textAlign: "right",
      },
      Cell: ({ value }) => {
        return value.toLocaleString("en-En");
      },
    },
    {
      text: "หัวหน้ากลุ่ม",
      dataField: "assocmaster",
      sort: true,
      editable: false,
      headerSortingStyle,
      headerStyle: () => {
        return { width: "10%" };
      },
      style: {
        textAlign: "right",
      },
    },
    {
      text: "เสียชีวิต",
      dataField: "dead",
      sort: true,
      editable: false,
      headerSortingStyle,
      headerStyle: () => {
        return { width: "10%" };
      },
      style: {
        textAlign: "right",
      },
    },
    {
      text: "ขาดส่ง 3 ปี",
      dataField: "no3yr",
      sort: true,
      editable: false,
      headerSortingStyle,
      headerStyle: () => {
        return { width: "10%" };
      },
      style: {
        textAlign: "right",
      },
    },
    {
      text: "ข้อมูล",
      dataField: "view",
      isDummyField: true,
      editable: false,
      formatter: actionsViewFormatter,
      headerStyle: () => {
        return { width: "5%" };
      },
      style: {
        textAlign: "center",
      },
      csvExport: false,
    },
  ];

  // const headers = [
  //   ...columns.map((a) => {
  //     return { label: a.text, key: a.dataField, CSVExport: a.CSVExport };
  //   }),
  // ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  // if (loading)
  //   return (
  //     <>
  //       <br />
  //       <p>
  //         <Spinner animation="border" variant="success" />
  //         <span>&nbsp;กรุณารอ เนื่องจากข้อมูลมีปริมาณมาก</span>
  //       </p>
  //     </>
  //   );
  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      {/* {JSON.stringify(data)} */}
      <ModalCheckMember
        show={showFormCheck}
        hidefunc={(a) => setShowFormCheck(a)}
        onClickAdd={clickAddMember}
        assocdata={association}
      />
      <MemberForm
        show={showMemberForm}
        hidden_func={(a) => setShowMemberForm(a)}
        farmerdata={farmer}
        assocdata={association}
        onsubmit={onSubmitSave}
      />
      <ModalViewDetail
        show={show_view}
        data={association}
        setdata={(b) => setData(b)}
        hidden={(a) => setShow_view(a)}
        onclose={handleCloseView}
      />
      <ModalAddAssociation
        show={show_add}
        data={data}
        setdata={(b) => setData(b)}
        hidden={(a) => setShow_add(a)}
        onsubmit={onSubmitAssocSave}
      />
      <ModalEditAssociation
        show={show_edit}
        hidden={(a) => setShow_edit(a)}
        data={association}
        assocdata={data}
        setdata={(b) => setData(b)}
        userid={user_id}
      />
      <ToolkitProvider
        bootstrap4
        keyField="association_id"
        data={data}
        columns={columns}
        // search
        exportCSV={{
          fileName: "ข้อมูลสมาคม.csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <Row>
                <Col md={9}>
                  <Form className="d-flex">
                    <Col md={1}>ค้นหา : </Col>
                    <Col md={3}>
                      <Form.Select
                        size="sm"
                        name="statusSearch"
                        value={search.statusSearch}
                        onChange={(e) => setField(e.target, e.target.value)}
                      >
                        <option value="">-- สถานะ --</option>
                        {optionActive.map((o) => (
                          <option key={o.value} value={o.value}>
                            {o.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <Form.Select
                        size="sm"
                        name="regionSearch"
                        value={search.regionSearch}
                        // onChange={handleSearchDopaChange}
                        onChange={(e) => setField(e.target, e.target.value)}
                      >
                        <option value="">-- ภูมิภาค --</option>
                        {optionRegion.map((b) => (
                          <option key={b.value} value={b.value}>
                            {b.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={4}>
                      <FormControl
                        size="sm"
                        name="textSearch"
                        value={search.textSearch}
                        type="search"
                        placeholder="รหัส / ชื่อสมาคม"
                        aria-label="Search"
                        // onChange={handleSearchChange}
                        onChange={(e) => setField(e.target, e.target.value)}
                      />
                    </Col>
                    <Col md={1}>
                      <Button
                        className="btn btn-info"
                        onClick={handleSearch}
                        style={{
                          margin: "0 0 0 0.5rem",
                          padding: ".375rem .75rem",
                          fontSize: ".75rem",
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </Button>
                    </Col>
                  </Form>
                </Col>
                <Col md={3}>
                  {/* <SearchBar {...prop.searchProps} placeholder="ค้นหา" /> */}
                  {showCSVButton(prop)}
                </Col>
              </Row>
            </div>
            <BootstrapTable
              pagination={pagination}
              keyField="associd"
              data={data}
              width={100}
              columns={columns}
              filter={filterFactory()}
              // headerClasses="header-class"
              {...prop.baseProps}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                beforeSaveCell(oldValue, newValue, row, column, done) {
                  setTimeout(() => {
                    if (confirm("ยืนยันการเปลี่ยนแปลง")) {
                      done(); // contine to save the changes
                    } else {
                      done(false); // reject the changes
                    }
                  }, 0);
                  return { async: true };
                },
                afterSaveCell: (oldValue, newValue, row, column) => {
                  changeStatus({
                    associd: row.association_id,
                    assocstatus: newValue,
                  });
                  console.log(oldValue);
                  console.log(newValue);
                  console.log(row);
                  console.log(column);
                  console.log("After Saving Cell!! ");
                },
              })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default AssociationSummary;
